angular.module('meevo.plugins.docsAndForms')
    .directive('iframeOnload', [function () {
        return {
            scope: {
                callBack: '&iframeOnload'
            },
            link: function (scope: ng.IScope, element: JQuery) {
                element.on('load', function () {
                    return scope.callBack({ iframeElement: element[0] });
                });

                scope.$on('$destroy', function () {
                    element.off('load');
                });
            }
        }
    }]);
